<template>
    <v-row justify="center">
        <v-col class="activated-junior" lg="6" md="6" sm="10">
            <h1 id="title">Success!</h1>
            <p>Your Junior ASCA Membership for {{firstName}} {{lastName}} has been activated!</p>
            <p>They'll now be able to access their account.</p>
            <v-btn v-on:click="onReturn()">RETURN HOME</v-btn>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import Vue from 'vue';
import FooterText from '../../../components/common/FooterText.vue';

export default Vue.extend({
    components: { FooterText },
    name: 'ActivatedJunior',
    data() {
        const parentVerification = this.$store.state.parentVerification;

        return {
            firstName: parentVerification.firstName,
            lastName: parentVerification.lastName,
        };
    },
    methods: {
        onReturn() { this.$navigate('/login'); }
    }
});
</script>
